import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';

import { openLinkRequest, isNativeEnv } from '../../../../utils/nativeBridge';

import styles from './style';
import Paper from '../../../../components/atomic/Paper';
import { getRedirectToken } from '../../../../api/mixins';
import useActionDialog from '../../../../hooks/useActionDialog';
import ExternalLink from '../../../../assets/icons/ExternalLink';
import Typography from '../../../../components/atomic/Typography';
import { privateSectionUrlInLegacyApp } from '../../../../config';
import ProgressButton from '../../../../components/ProgressButton';

export const PersonalDocumentsRedirect = ({
  classes,
  className,
  showTitle = true,
  buttonOnly = false,
}) => {
  const { showErrorMessage } = useActionDialog();
  const [requestInProgress, setRequestInProgress] = useState(false);

  const redirectToDocuments = async () => {
    setRequestInProgress(true);

    // use this workaround with window reference
    // to make it work on ios/safari: https://stackoverflow.com/a/39387533
    const windowReference = isNativeEnv() ? null : window.open();

    const [error, code] = await getRedirectToken();

    if (!error && code) {
      const link = `${privateSectionUrlInLegacyApp}?code=${code}`;

      if (isNativeEnv()) {
        openLinkRequest(link);
      } else {
        windowReference.location = `${privateSectionUrlInLegacyApp}?code=${code}`;
      }
    } else {
      showErrorMessage(error);
    }

    setRequestInProgress(false);
  };

  const button = (
    <ProgressButton
      size="small"
      color="primary"
      variant="contained"
      className={classes.button}
      onClick={redirectToDocuments}
      requestInProgress={requestInProgress}
    >
      Se private dokumenter&nbsp;&nbsp;
      <ExternalLink width={15} height={15} />
    </ProgressButton>
  );

  if (buttonOnly) {
    return button;
  }

  return (
    <Paper elevation={2} className={clsx(classes.paper, className)}>
      {showTitle && (
        <Typography
          variant="h3"
          gutterBottom
          paragraph
          component="h3"
          color="textPrimary"
        >
          Personlige dokumenter
        </Typography>
      )}

      <Typography paragraph variant="body2">
        Vi pusser opp! Personlige dokumenter er tilgjengelig i gammel løsning.
      </Typography>
      {button}
    </Paper>
  );
};

PersonalDocumentsRedirect.defaultProps = {
  showTitle: true,
  buttonOnly: false,
};

PersonalDocumentsRedirect.propTypes = {
  // classes,
  // className,
  showTitle: PropTypes.bool,
  buttonOnly: PropTypes.bool,
};

export default withStyles(styles)(PersonalDocumentsRedirect);
